import * as _ from "lodash";
import {ExternalPromise} from "./utils/ExternalPromise";


export class LoadingProgress {
	protected _onChange: ((LoadingProgress) => void)[] = [];
	protected _onLoaded: ExternalPromise = new ExternalPromise();

	constructor(
		public _total: number = 0,
		public _loaded: number = 0
	){
	}

	onDone(): Promise<void>{
		return new Promise<void>((resolve, reject) => {
			this._onLoaded.then(resolve, reject);
		});
	}

	/**
	 * Register onchange callback;
	 * @param callback
	 */
	onChange(callback:(LoadingProgress) => void){
		this._onChange.push(callback);
	}

	/**
	 * Percentual ammount of loaded resources
	 */
	get percent(): number{
		return (this._loaded / this.total) * 100;
	}

	/**
	 * resolve single loaded item
	 */
	resolve(){
		this._loaded++;
		for (let onChangeCallback of this._onChange)
			onChangeCallback(this);

		if (this._loaded >= this._total)
			this._onLoaded.resolve();
	}

	get loaded():number{
		return this._loaded;
	}

	/**
	 * Adds new item and returns self-reference
	 */
	add(){
		this._total++;
		for (let onChangeCallback of this._onChange)
			onChangeCallback(this);
		return this;
	}

	get total():number{
		return this._total;
	}
}

export class ComposedLoadingProgress {
	protected sets:{[id:string]:LoadingProgress} = {};
	protected _onChange: ((ComposedLoadingProgress) => void)[] = [];

	add(id: string, progress: LoadingProgress){
		this.sets[id] = progress;
		progress.onChange(() => {
			this.changed(this);
		})
	}

	get total(): number {
		let total = 0;
		_.each(this.sets, (set:LoadingProgress) => {
			total += set.total;
		});
		return total;
	}

	get loaded(): number {
		let loaded = 0;
		_.each(this.sets, (set:LoadingProgress) => {
			loaded += set.loaded;
		});
		return loaded;
	}

	get percent(): number{
		return (this.loaded / this.total) * 100;
	}

	protected changed(_this){
		for (let onChangeCallback of this._onChange)
			onChangeCallback(_this);
	}

	/**
	 * Register onchange callback;
	 * @param callback
	 */
	onChange(callback:(ComposedLoadingProgress) => void){
		this._onChange.push(callback);
	}

	toString(){
		return `${this.loaded} / ${this.total}`;
	}

	/**
	 * OnDone for all currently initialized loaders
	 */
	onDone(): Promise<void>{
		return new Promise<void>((resolve, reject) => {
			let promises:Promise<void>[] = [];
			_.each(this.sets, (set) => {
				promises.push(set.onDone());
			});
			Promise.all(promises).then(() => { resolve(); }, reject);
		});
	}
}




// WEBPACK FOOTER //
// ./src/script/app3D/LoadingProgress.ts